import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isMiniMergeboxEnabled() {
  return isFeatureEnabled('prs_overview_mini_merge_status')
}
